import {errorCodes} from './ErrorCodes';

const getErrorMessage = (error) => {
  if (error && error.message) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'Network error. Failed to fetch';
};

const getResponseErrorMessage = (responseData, statusText) => {
  if (responseData.message) {
    return responseData.message;
  }
  if (responseData.error) {
    return responseData.error;
  }
  if (typeof responseData.data === 'object' && responseData.data !== null) {
    return JSON.stringify(responseData.data);
  }
  return statusText;
};

export const HTTP_GET = async (url = false) => {
  const controller = new AbortController();
  const signal = controller.signal;
  setTimeout(() => controller.abort(), 15000);

  var jsonResponse = {success: false, statusCode: errorCodes.UNDEFINED, data: ''};

  const accessToken = localStorage.getItem('token');

  // Application Headers
  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  // Add Authorization Header if Present
  if (accessToken != null) {
    headers['Authorization'] = 'Bearer ' + accessToken;
  }

  return fetch(url, {
    signal: signal,
    method: 'GET',
    headers: headers
  })
    .then((response) =>
      response.json().then((responseData) => {
        jsonResponse.statusCode = response.status;
        jsonResponse.data = responseData.data;

        if (Array.isArray(jsonResponse.data)) {
          jsonResponse.total = responseData.total || jsonResponse.data.length;
        }
        if (response.status === 200) {
          jsonResponse.success = true;
        } else if (!jsonResponse.data || typeof jsonResponse.data === 'object') {
          jsonResponse.data = getResponseErrorMessage(responseData, response.statusText);
        }
        return jsonResponse;
      })
    )
    .catch((error) => {
      if (error.name === 'AbortError') {
        jsonResponse.statusCode = errorCodes.REQUEST_TIMED_OUT;
        jsonResponse.data = 'Request Timed out. Please try again later';
        return jsonResponse;
      } else {
        jsonResponse.statusCode = errorCodes.NETWORK_ERROR;
        jsonResponse.data = getErrorMessage(error);

        return jsonResponse;
      }
    });
};

export const HTTP_POST = async (url, body) => {
  const controller = new AbortController();
  const signal = controller.signal;
  setTimeout(() => controller.abort(), 15000);

  var jsonResponse = {success: false, statusCode: errorCodes.UNDEFINED, data: ''};

  const accessToken = localStorage.getItem('token');

  // Application Headers
  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  // Add Authorization Header if Present
  if (accessToken != null) {
    headers['Authorization'] = 'Bearer ' + accessToken;
  }

  return fetch(url, {
    signal: signal,
    method: 'POST',
    //mode: 'no-cors',
    headers: headers,
    body: JSON.stringify(body)
  })
    .then((response) =>
      response.json().then((responseData) => {
        jsonResponse.statusCode = response.status;
        jsonResponse.data = responseData.data;

        if (Array.isArray(jsonResponse.data)) {
          jsonResponse.total = jsonResponse.data.length;
        }

        if (response.status === 200) {
          jsonResponse.success = true;
        } else if (!jsonResponse.data || typeof jsonResponse.data === 'object') {
          jsonResponse.data = getResponseErrorMessage(responseData, response.statusText);
        }
        return jsonResponse;
      })
    )
    .catch((error) => {
      if (error.name === 'AbortError') {
        jsonResponse.statusCode = errorCodes.REQUEST_TIMED_OUT;
        jsonResponse.data = 'Request Timed out. Please try again later';
        return jsonResponse;
      } else {
        jsonResponse.statusCode = errorCodes.NETWORK_ERROR;
        jsonResponse.data = getErrorMessage(error);
        return jsonResponse;
      }
    });
};

export const HTTP_DELETE = async (url, body) => {
  const controller = new AbortController();
  const signal = controller.signal;
  setTimeout(() => controller.abort(), 15000);

  var jsonResponse = {success: false, statusCode: errorCodes.UNDEFINED, data: ''};

  const accessToken = localStorage.getItem('token');

  // Application Headers
  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  // Add Authorization Header if Present
  if (accessToken != null) {
    headers['Authorization'] = 'Bearer ' + accessToken;
  }

  return fetch(url, {
    signal: signal,
    method: 'DELETE',
    //mode: 'no-cors',
    headers: headers,
    body: JSON.stringify(body)
  })
    .then((response) =>
      response.json().then((responseData) => {
        jsonResponse.statusCode = response.status;
        jsonResponse.data = responseData.data;

        if (Array.isArray(jsonResponse.data)) {
          jsonResponse.total = jsonResponse.data.length;
        }

        if (response.status === 200) {
          jsonResponse.success = true;
        } else if (!jsonResponse.data || typeof jsonResponse.data === 'object') {
          jsonResponse.data = getResponseErrorMessage(responseData, response.statusText);
        }

        return jsonResponse;
      })
    )
    .catch((error) => {
      if (error.name === 'AbortError') {
        jsonResponse.statusCode = errorCodes.REQUEST_TIMED_OUT;
        jsonResponse.data = 'Request Timed out. Please try again later';
        return jsonResponse;
      } else {
        jsonResponse.statusCode = errorCodes.NETWORK_ERROR;
        jsonResponse.data = getErrorMessage(error);

        return jsonResponse;
      }
    });
};
